import { render, staticRenderFns } from "./AdminMcp.vue?vue&type=template&id=ad706992&scoped=true&"
import script from "./AdminMcp.vue?vue&type=script&lang=js&"
export * from "./AdminMcp.vue?vue&type=script&lang=js&"
import style0 from "./AdminMcp.vue?vue&type=style&index=0&id=ad706992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad706992",
  null
  
)

component.options.__file = "www/vues/admin/AdminMcp.vue"
export default component.exports